import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
    },
    {
        path: '/loginsso',
        name: 'LoginSSO',
        component: () => import('../views/LoginSSO.vue'),
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () => import('../views/Logout.vue'),
    },
    {
        path: '/jobsite',
        name: 'Jobsite',
        component: () => import('../views/Jobsite.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/historical-data/:id',
        props: true,
        name: 'JobsiteId',
        component: () => import('../views/HistoricalData.vue'),
        meta: {
            requiresAuth: true,

        },
    },
    {
        path: '/historical-data',
        name: 'Historical Data',
        component: () => import('../views/HistoricalData.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/jobsite-setup',
        name: 'Jobsite Setup',
        component: () => import('../views/JobsiteSetup.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/mail',
        name: 'Mail',
        component: () => import('../views/Mail.vue'),
    },
    {
        path: '/maps',
        name: 'Maps',
        component: () => import('../views/Maps.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/users',
        name: 'Users',
        component: () => import('../views/Users.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/mailview',
        name: 'Mail View',
        component: () => import('../views/Mailview.vue'),
        meta: {
            requiresAuth: true,
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
